import { headingStyling } from "@made-people/blueprint-heading/blueprint";

headingStyling.override({
  slots: {
    base: "relative",
    heading: "",
    lead: "mt-3 first:mt-0",
    eyebrow: "mb-1 block",
    badge: "mb-2",
  },
  variants: {
    headingSize: {
      "2xs": {
        heading: "text-heading-2xs font-primary text-balance",
      },
      xs: {
        heading: "text-heading-xs font-primary text-balance",
      },
      sm: {
        heading: "text-heading-sm font-primary text-balance",
      },
      md: {
        heading: "text-heading-md font-primary text-balance",
      },
      lg: {
        heading: "text-heading-lg font-primary text-balance",
      },
      xl: {
        heading: "text-heading-xl font-secondary text-balance",
      },
      "2xl": {
        heading: "text-heading-2xl font-secondary text-balance",
      },
      "display-lg": {
        heading: "text-heading-display-lg font-secondary text-balance",
      },
      "display-md": {
        heading: "text-heading-display-md font-secondary text-balance",
      },
      "display-sm": {
        heading: "text-heading-display-sm font-secondary text-balance",
      },
    },
    leadSize: {
      "2xs": {
        lead: "text-body-2xs",
      },
      xs: {
        lead: "text-body-xs",
      },
      sm: {
        lead: "text-body-sm",
      },
      md: {
        lead: "text-md-md",
      },
      lg: {
        lead: "text-body-lg",
      },
    },
    eyebrowSize: {
      "2xs": {
        eyebrow: "text-body-2xs font-bold",
      },
      xs: {
        eyebrow: "text-body-xs font-bold",
      },
      sm: {
        eyebrow: "text-body-sm font-bold",
      },
      md: {
        eyebrow: "text-body-md font-bold",
      },
      lg: {
        eyebrow: "text-body-lg font-bold",
      },
    },
  },
});
